import { isValid } from 'date-fns';

import { getUTCDayEnd, getUTCDayStart } from '@/utils/helpers/get-utc-day';

const isIncidentActiveOnDate = (
  start?: string | null,
  end?: string | null,
  targetDate?: Date
): boolean => {
  const checkDate = targetDate || new Date();

  const dayStart = getUTCDayStart(checkDate);
  const dayEnd = getUTCDayEnd(checkDate);

  const startDate = start ? new Date(start) : null;
  const endDate = end ? new Date(end) : null;

  const incidentStart =
    startDate && isValid(startDate) ? startDate.getTime() : Number.MIN_SAFE_INTEGER;

  const incidentEnd = endDate && isValid(endDate) ? endDate.getTime() : Number.MAX_SAFE_INTEGER;

  return incidentStart <= dayEnd && incidentEnd >= dayStart;
};

export default isIncidentActiveOnDate;
